import { Injectable } from '@angular/core';
import * as _ from 'lodash';

import { SortModel } from 'shared/search/sort.model';
import { SearchService } from 'shared/search/search.service';
import { SearchModel } from 'shared/search/search.model';
import { RECEIVERS } from 'shared/search/search-service-types';
import { Config } from 'shared/config/env.config';

import { statusLookup } from '../receivers-statuses';
// import { receivers } from './receivers-search-stub';


@Injectable()
export class ReceiversSearchService extends SearchService {

  // extendable fields:
  searchModel: SearchModel = new SearchModel();
  serviceType = RECEIVERS;
  idField = '_id';

  statusLookup: Array<any> = statusLookup;
  doUpdate: boolean = true;

  getSearchURI(brandId: string, searchModel: SearchModel): string {
    return `/receivers/${brandId}`;
  }

  // redefine parent method
  getQueryString(searchModel: SearchModel): string {
    const status: string = (searchModel.statusModel) ? searchModel.statusModel.id.toString() : '';
    const sortCol: string = (searchModel.sortModel) ? searchModel.sortModel.column : '';
    const sortDir: string = (searchModel.sortModel) ? searchModel.sortModel.sort : '';
    const queryString: string =
      'page=' + searchModel.currentPage +
      '&itemsPerPage=' + searchModel.itemsPerPage +
      '&search=' + encodeURIComponent(searchModel.searchValue.trim()) +
      '&status=' + status +
      '&sortCol=' + sortCol +
      '&sortDir=' + sortDir +
      this.getSimpleFiltersQueryString() +
      this.getArrayFiltersQueryString();
    // TODO:
    // add tag filters from advanced search
    return queryString;
  }

  handleSearchRes(res: any) {
    this.updateData(res);
  }

  // redefine parent methods
  getSelectedStatusCounts() {
    if (!this.allSelected) {
      const statusCounts = _.countBy(this.selectedItems, (item: any) => {
        return item.status;
      });

      return _.map(statusCounts, (count, id) => {
        return {statusId: id, count: count};
      });

    } else {
      // the differense from search.servise is that here is searchAmount used for counts, not statusAmount
      const statusCounts: any = _.filter(this.statuses, (status) => status.searchAmount > 0);
      return _.map(statusCounts, (statusCount: any) => {
        return {statusId: statusCount.id, count: statusCount.searchAmount};
      });
    }
  }
}
